<template>
    <DsCard>
        <div class="grid place-items-center p-2">
            <DsIcon
                class="mb-4 text-content-primary"
                icon="fa-regular fa-circle-exclamation"
                size="lg"
            />
            <h3 class="mb-1 text-content-lg font-medium text-content-primary">Unable to load content</h3>
            <p class="mb-3 text-content-md text-content-secondary">Something went wrong loading this information.</p>
            <DsButton
                class="w-fit"
                size="sm"
                variant="tertiary"
                @click="$emit('refetch')"
            >
                Try again
            </DsButton>
        </div>
    </DsCard>
</template>

<script setup lang="ts">
import DsCard from '@ds/DsCard.vue';
import DsIcon from '@ds/DsIcon.vue';
import DsButton from '@ds/button/DsButton.vue';

defineEmits<{
    refetch: [];
}>();
</script>
